module.exports = "//static.hsappstatic.net/conversations-visitor-experience-components/static-1.12040/img/visitor-widget/bot-avatar.svg"